import { render, staticRenderFns } from "./body1.vue?vue&type=template&id=c9b369ac&scoped=true&"
import script from "./body1.vue?vue&type=script&lang=js&"
export * from "./body1.vue?vue&type=script&lang=js&"
import style0 from "./body1.vue?vue&type=style&index=0&id=c9b369ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b369ac",
  null
  
)

export default component.exports